module.exports = __webpack_public_path__ + "first-5-raised_print.jpg?ced475e929121244ce0da932aff9a317";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5-raised_print.jpg
// module id = 517
// module chunks = 0